<template>
  <v-card>
    <v-card-title>
      {{ message.title }}
      <v-spacer></v-spacer>
      <small><date-formatter :value="message.created_at"></date-formatter></small>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <div v-html="message.content.replace(/\n/g, '<br/>')"></div>
      <attachment
        v-for="attachment in message.attachments" :key="attachment.url"
        :url="attachment.url"
        :filename="attachment.filename">
      </attachment>
    </v-card-text>
  </v-card>
</template>

<script>
  import { Date as DateFormatter } from '@/components/formatters'
  import Attachment from '@/components/Attachment.vue'
  import purchase from '@/mixins/purchase'
  export default {
    components: {
      DateFormatter,
      Attachment
    },
    props: {
      message: {
        type: Object,
        required: true
      }
    },
    mixins: [purchase]
  }
</script>



// WEBPACK FOOTER //
// src/components/purchase/Message.vue